// this file is a shortcut for...
export { useColors as default } from 'src/contexts/colors';
